<!--
 * @Description:联系人
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-02 17:43:59
 * @LastEditors: cxh
-->
<template>
  <CosModal
    v-model:visible="visible"
    :title="form.id ? '编辑' : '新增'"
    class="clueMerge"
    width="870px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="form" ref="formRef" v-if="visible">
      <dc-layout-card :span="12">
        <dc-form-item
          name="name"
          :rules="[
            {
              required: true,
              message: '请输入'
            },
            { validator: concatNameValidate }
          ]"
          label="联系人姓名"
        >
          <CosInput v-model:value="form.name" placeholder="请输入" :maxlength="50" />
        </dc-form-item>
        <dc-form-item
          name="mobile"
          label="手机号"
          :rules="[
            {
              validator: (rule, value) => contactValidate(rule, value, form, formRef)
            }
          ]"
        >
          <CosInput v-model:value="form.mobile" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="email"
          label="邮箱"
          :rules="[
            {
              validator: (rule, value) => contactValidate(rule, value, form, formRef)
            }
          ]"
        >
          <CosInput v-model:value="form.email" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="wechat"
          label="微信号"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <CosInput v-model:value="form.wechat" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="qq"
          label="QQ号"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <CosInput v-model:value="form.qq" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item
          name="tel"
          label="固定电话"
          :rules="{
            validator: (rule, value) => contactValidate(rule, value, form, formRef)
          }"
        >
          <CosInput v-model:value="form.tel" placeholder="请输入，联系方式必填其一" />
        </dc-form-item>
        <dc-form-item label="性别">
          <CosSelect v-model:value="form.sex" :options="dataConfig.genderEnum" placeholder="请选择" allow-clear />
        </dc-form-item>
        <dc-form-item
          label="角色"
          name="jobRole"
          :rules="{
            message: '请选择',
            validator: selectForNumberValidate,
            required: true
          }"
        >
          <CosSelect
            v-model:value="form.jobRole"
            :options="dataConfig.linkRoleTypeEnum"
            placeholder="请选择"
            allow-clear
          />
        </dc-form-item>
        <dc-form-item
          label="职务"
          name="jobDuty"
          :rules="{
            message: '请选择',
            validator: selectForNumberValidate,
            required: true
          }"
        >
          <ParamCodesSelect v-model:value="form.jobDuty" :options="paramCodeData.lbu_department_title" />
        </dc-form-item>
        <dc-form-item label="传真号">
          <a-input v-model:value="form.fax" placeholder="请输入" />
        </dc-form-item>
        <dc-form-item label="备注" :span="24">
          <CosTextarea v-model:value="form.remark" :maxlength="2000" />
        </dc-form-item>
      </dc-layout-card>
    </a-form>
  </CosModal>
</template>
<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import dataConfig from '@/views/yuntuSales/commonEnum/dataConfig'
import { customerContactAdd, customerContactEdit } from '@/api/yuntuSales/customerCenter'
import { listByParamCodes } from '@/api/common'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { cloneDeep } from 'lodash-es'
import { contactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import CosInput from '@/components/Antd/CosInput/index.vue'
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PotentialItem['contact']>({})
const props = defineProps({
  contactRefId: {
    type: String
  }
})
const emit = defineEmits(['success'])
const paramCodeData = reactive<{
  lbu_department_title: []
}>({
  lbu_department_title: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_department_title']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
const success = (type: 'add' | 'edit', res: any) => {
  emit('success', type, res)
}
const toggle = (row: PotentialItem['contact']) => {
  form.value = row ? cloneDeep(row) : {}
  visible.value = true
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      if (form.value?.id) {
        const res = await customerContactEdit(form.value)
        message.success('编辑成功')
        success('edit', res)
      } else {
        const res = await customerContactAdd({
          ...form.value,
          contactRefId: props.contactRefId
        })
        message.success('新增成功')
        success('add', res)
      }
      visible.value = false
    } catch (error) {}
    loading.value = false
  })
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default {
  name: 'ContactsModal'
}
</script>
